import { TourGuide } from '../models/tour.model'

/**
 * 'welcome-users' tour — a real flow with 3 business steps:
 *   1. On the reports list: "Choose a patient" (floating banner). Tapping a
 *      card opens the report modal AND advances the tour.
 *   2. Inside the modal: "Taking vitals" — tapping it advances.
 *   3. A two-part modal guide (both array entries are step 3): the measuring
 *      instructions, ending on "Got it!".
 *
 * Steps whose target only exists once the modal is open wait for it.
 */
export const WELCOME_USERS_TOUR: TourGuide = {
  id: 'welcome-users',
  total: 4,
  steps: [
    {
      anchor: 'choose-patient',
      number: 1,
      title: 'Choose a patient',
      text: 'Tap any patient card to record vitals.',
      layout: 'horizontal',
      backdrop: false,
      arrow: false,
      floating: true,
      audio: 'assets/guide/step1.mp3'
    },
    {
      anchor: 'choose-vitals',
      number: 2,
      title: 'Taking vitals',
      text: 'Tap ”Taking vitals” to begin',
      placement: 'top',
      audio: 'assets/guide/step2.mp3'
    },
    {
      anchor: 'measure-vitals',
      number: 3,
      layout: 'modal',
      waitForAnchor: true,
      title: 'Measuring vitals',
      modalTitle: 'Proper Placement of Measuring Devices',
      audio: 'assets/guide/measuring-1.mp3',
      image: 'assets/guide/measuring-1.png',
      nextButton: 'Next'
    },
    {
      anchor: 'measure-vitals',
      number: 3,
      layout: 'modal',
      waitForAnchor: true,
      title: 'Measuring vitals',
      modalTitle: 'How to measure vital signs properly',
      image: 'assets/guide/measuring-2.png',
      audio: 'assets/guide/measuring-2.mp3',
      nextButton: 'Got it!',
      nextButtonIcon: 'icons:rocket-stroke-regular',
      // "Got it!" dismisses the guide; step 4 is resumed manually from the
      // component (when device vitals arrive) via `TourService.next()`.
      suspendOnNext: true
    },
    {
      anchor: 'report-emr',
      number: 4,
      title: 'Report to EMR',
      text: 'Tap ״Report to EMR” to upload vitals to EMR',
      audio: 'assets/guide/tap-report.mp3',
      placement: 'top',
      backdrop: false
    },
    // Post-send confirmation modals (no stepper) shown over the confetti card.
    {
      anchor: 'confetti-card',
      layout: 'modal',
      hideStepper: true,
      // Wait for the confetti card to appear after reporting (no timeout).
      waitForAnchor: true,
      waitTimeout: 0,
      modalTitle: 'Vitals sent successfully!',
      image: 'assets/guide/sent-1.png',
      audio: 'assets/guide/sent-1.mp3',
      nextButton: 'Next'
    },
    {
      anchor: 'confetti-card',
      layout: 'modal',
      hideStepper: true,
      modalTitle: 'Vitals sent successfully!',
      image: 'assets/guide/sent-2.png',
      audio: 'assets/guide/sent-2.mp3',
      nextButton: 'Next'
    },
    {
      anchor: 'confetti-card',
      layout: 'modal',
      hideStepper: true,
      modalTitle: 'Vitals sent successfully!',
      image: 'assets/guide/sent-3.png',
      audio: 'assets/guide/sent-3.mp3',
      nextButton: 'Next'
    },
    // Final modal — custom "Training complete!" content (see
    // TrainingCompleteCardComponent, registered under this key).
    {
      anchor: 'confetti-card',
      audio: 'assets/guide/complete.mp3',
      layout: 'modal',
      hideStepper: true,
      waitForAnchor: false,
      templateKey: 'training-complete'
    }
  ]
}
